import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import CoffeeHeader from '../components/coffee/CoffeeHeader';
import CoffeeFilters from '../components/coffee/CoffeeFilters';
import CoffeeList from '../components/coffee/CoffeeList';
import CreateCoffeeModal from '../components/coffee/CreateCoffeeModal';
import { XIcon } from 'lucide-react';
const EIISCoffeePage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState<'all' | 'upcoming' | 'mine' | 'past'>('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedTopic, setSelectedTopic] = useState('all');
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  return <div className="flex h-screen bg-gray-100" data-id="element-2374">
      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-2375">
        {/* Sidebar backdrop */}
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-2376"></div>
        {/* Sidebar */}
        <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black" data-id="element-2377">
          <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-2378">
            <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-2379">
              <span className="sr-only" data-id="element-2380">Close sidebar</span>
              <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-2381" />
            </button>
          </div>
          <div className="flex-1 h-full overflow-y-auto" data-id="element-2382">
            <Sidebar activePage="community" data-id="element-2383" />
          </div>
        </div>
      </div>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0" data-id="element-2384">
        <Sidebar activePage="community" data-id="element-2385" />
      </div>

      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-2386">
        <Topbar onMenuClick={() => setSidebarOpen(true)} data-id="element-2387" />

        <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-2388">
          <div className="pt-4 md:pt-6 max-w-6xl mx-auto" data-id="element-2389">
            <CoffeeHeader onCreateClick={() => setIsCreateModalOpen(true)} data-id="element-2390" />

            <div className="mt-6" data-id="element-2391">
              <CoffeeFilters activeFilter={activeFilter} setActiveFilter={setActiveFilter} searchQuery={searchQuery} setSearchQuery={setSearchQuery} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic} data-id="element-2392" />
            </div>

            <div className="mt-6" data-id="element-2393">
              <CoffeeList activeFilter={activeFilter} searchQuery={searchQuery} selectedTopic={selectedTopic} data-id="element-2394" />
            </div>
          </div>
        </main>
      </div>

      {/* Create Event Modal */}
      <CreateCoffeeModal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} data-id="element-2395" />
    </div>;
};
export default EIISCoffeePage;